import { ForEachWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ForEach')
export class ForEachNodeSchemaProvider extends SchemaProvider<ForEachWorkflowNode> {}
